import { Box, CircularProgress, Typography } from "@mui/material";

const LoadingState = ({ message = "Loading…", minHeight = 240 }) => (
  <Box
    role="status"
    aria-live="polite"
    sx={{
      minHeight,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 1.5,
      color: "text.secondary",
    }}
  >
    <CircularProgress size={28} thickness={4} />
    <Typography variant="body2">{message}</Typography>
  </Box>
);

export default LoadingState;
